// Inline SVG icons for the "What we treat" cards that lucide doesn't cover.
// Kept intentionally lightweight — mirrors the visual weight of lucide-react
// icons at the same 22 px size the cards render.

export function BloodDropIcon({ size = 22, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 2c3 4.5 6 8.3 6 12a6 6 0 0 1-12 0c0-3.7 3-7.5 6-12z" />
    </svg>
  );
}

export function LdlDropIcon({ size = 22, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 2c3 4.5 6 8.3 6 12a6 6 0 0 1-12 0c0-3.7 3-7.5 6-12z" />
      <text
        x="12"
        y="17"
        textAnchor="middle"
        fontSize="6.2"
        fontWeight="700"
        fill="currentColor"
        stroke="none"
        style={{ fontFamily: "system-ui, sans-serif", letterSpacing: "0.02em" }}
      >
        LDL
      </text>
    </svg>
  );
}
